export default __webpack_public_path__ + "static/hero_discover-d26be83ac4ec3001446c4c9b7d86c175.mp4";